<template>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32" height="32" viewBox="0 0 32 32">
		<defs>
			<clipPath id="clip-path-me-andm-me">
				<rect id="Rectangle_15495" data-name="Rectangle 15495" width="32" height="32" transform="translate(-0.352 -0.352)" fill="none" />
			</clipPath>
		</defs>
		<g id="Group_45900" data-name="Group 45900" transform="translate(0.352 0.352)">
			<g id="Group_45895" data-name="Group 45895" clip-path="url(#clip-path-me-andm-me)">
				<path
					id="Path_33030"
					data-name="Path 33030"
					d="M31.3,15.648A15.648,15.648,0,1,0,15.648,31.3,15.648,15.648,0,0,0,31.3,15.648"
					fill="#fff"
				/>
				<path
					id="Path_33031"
					data-name="Path 33031"
					d="M15.648,0A15.648,15.648,0,1,0,31.3,15.648,15.648,15.648,0,0,0,15.648,0"
					fill="#969bae"
				/>
				<path
					id="Path_33032"
					data-name="Path 33032"
					d="M11.1,12.128a3.255,3.255,0,0,0,3.159-3.1,3.241,3.241,0,0,0-3.109-3.172A3.247,3.247,0,0,0,8,8.928a3.24,3.24,0,0,0,3.108,3.2"
					transform="translate(4.516 3.311)"
					fill="#fff"
				/>
				<path
					id="Path_33033"
					data-name="Path 33033"
					d="M16.546,15.091a4.635,4.635,0,0,0-1.185-3.274,4.722,4.722,0,0,0-1.5-1.181c-.044-.022-.089-.042-.133-.063-.028-.014-.056-.027-.086-.039a4.413,4.413,0,0,0-1.449-.376c-.041,0-.081-.008-.122-.011s-.1-.008-.15-.009h0c-.061,0-.122,0-.183,0s-.122,0-.185,0h0c-.052,0-.1.006-.152.009s-.081.006-.122.011a4.433,4.433,0,0,0-1.449.376l-.086.039c-.044.02-.089.041-.133.063a4.734,4.734,0,0,0-1.494,1.181,4.63,4.63,0,0,0-1.186,3.274l0,.044h0c0,.1-.011,1.264.2,1.264h9.211c.214,0,.2-1.16.2-1.264h0l0-.044"
					transform="translate(3.912 5.726)"
					fill="#fff"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'MyselfSvg',
};
</script>
